import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { CoreLanguageService } from '../../services/language.service';
import { WebShopService } from '../../services/webShop.service';
import { ServiceOpenTimeViewModel } from '../../shared/models';
import { CoreLogService } from '../../services/log.service';

@Component({
  selector: 'ya-setnewordertimedialog',
  templateUrl: './setNewOrderTimeDialog.component.html',
  styleUrls: ['./setNewOrderTimeDialog.component.scss']
})
export class SetNewOrderTimeDialogComponent implements OnInit {
  public selecetedorderTime: ServiceOpenTimeViewModel;
  public modalDescription: string = "";
  public serviceOpenTimeViewModels: ServiceOpenTimeViewModel[];

  public get orderASAP(): boolean {
    return this._webShopService.orderASAP;
  }

  constructor(public bottomSheetRef: MatBottomSheetRef<SetNewOrderTimeDialogComponent>
    , private _webShopService: WebShopService
    , private _router: Router
    , private _coreLanguageService: CoreLanguageService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , @Inject(MAT_BOTTOM_SHEET_DATA) public isClosed: boolean) { }

  ngOnInit() {
    const me = this;
    me.loadAvailableTimes();
  }

  private async loadAvailableTimes() {
    const me = this;
    me.serviceOpenTimeViewModels = await me._webShopService.getAvailableServiceTimes();
    // Description based on service status
    if (me.isClosed) {
      me.modalDescription = me._coreLanguageService.value("phNewOrderTimeDialog_Description_Closed");
    } else {
      me.modalDescription = me._coreLanguageService.value("phNewOrderTimeDialog_Description");
    }

    // Select first available time as default
    if (me.serviceOpenTimeViewModels && me.serviceOpenTimeViewModels.length > 0) {
      me.selecetedorderTime = me.serviceOpenTimeViewModels[0];
    }
    me.PushChanges();
  }

  public confirm() {
    const me = this;
    me.bottomSheetRef.dismiss(me.selecetedorderTime);
  }

  public setRequestServiceTime(index: string) {
    const me = this;
    me.selecetedorderTime = me.serviceOpenTimeViewModels[+index];
  }

  navigateToService() {
    const me = this;
    me.bottomSheetRef.dismiss(null);
    me._router.navigateByUrl("/menuservice");
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("SetNewOrderTimeDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

}
